import {
  EMPLOYMENT_TYPE_FETCHING,
  EMPLOYMENT_TYPE_FAILED,
  EMPLOYMENT_TYPE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYMENT_TYPE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYMENT_TYPE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYMENT_TYPE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
